module.exports = __webpack_public_path__ + "static/img/cont37_10.bee4fd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont37_10.jpg
// module id = x/PL
// module chunks = 0